import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { IngestionPointCategory } from "../data.ingestion.service";
import { OrganizationService } from "../../../services/organization.service";
import { S25ItemI } from "../../../pojo/S25ItemI";

@TypeManagerDecorator("s25-ng-ingestion-subcategory-selector")
@Component({
    selector: "s25-ng-ingestion-subcategory-selector",
    template: `
        @if (category === "ENGAGEMENT") {
            @if (isEditing) {
                <s25-organization-dropdown
                    [(chosen)]="selectedOrganization"
                    (chosenChange)="onOrganizationChange($event)"
                ></s25-organization-dropdown>
            } @else {
                <div class="organization-display">
                    @if (organizationName) {
                        <span class="organization-name">{{ organizationName }}</span>
                    } @else {
                        <span class="no-organization">No organization selected</span>
                    }
                </div>
            }
        } @else if (category === "EVENT_SURVEY") {
            <div class="standalone-display">
                <span class="standalone-text">No subcategory needed - standalone survey</span>
            </div>
        } @else {
            <input
                class="c-input"
                type="text"
                [(ngModel)]="subCategory"
                (ngModelChange)="onSubCategoryTextChange($event)"
                [placeholder]="'Enter sub-category'"
                [disabled]="!isEditing"
            />
        }
    `,
    styles: `
        .organization-display,
        .standalone-display {
            padding: 0.5rem;
            background-color: #f8f9fa;
            border: 1px solid #dee2e6;
            border-radius: 4px;
            min-height: 38px;
            display: flex;
            align-items: center;
        }

        .organization-name {
            font-weight: 500;
            color: #495057;
        }

        .no-organization {
            color: #6c757d;
            font-style: italic;
        }

        .standalone-text {
            color: #6c757d;
            font-style: italic;
        }

        s25-organization-dropdown {
            display: inline-block;
            max-width: 350px;
            width: 80%;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class IngestionSubcategorySelectorComponent implements OnInit {
    @Input() category: IngestionPointCategory;
    @Input() subCategory: string;
    @Input() isEditing: boolean = true;
    @Input() onSubCategoryChange: (subCategory: string) => void;

    selectedOrganization: S25ItemI;
    organizationName: string;

    constructor(public cd: ChangeDetectorRef) {}

    ngOnInit() {
        if (this.category === "ENGAGEMENT" && this.subCategory && !this.isEditing) {
            void this.loadOrganizationName();
        }
        // EVENT_SURVEY doesn't need any initialization
    }

    onOrganizationChange = (organization: S25ItemI) => {
        if (organization && organization.itemId) {
            this.onSubCategoryChange(organization.itemId.toString());
        } else {
            this.onSubCategoryChange("");
        }
    };

    onSubCategoryTextChange = (value: string) => {
        this.onSubCategoryChange(value);
    };

    private loadOrganizationName = async () => {
        if (!this.subCategory) return;

        try {
            const orgId = parseInt(this.subCategory);
            if (isNaN(orgId)) return;

            const orgData = await OrganizationService.getOrganizationNameAndFormal(orgId);
            this.organizationName = orgData.itemName;
            this.cd.detectChanges();
        } catch (error) {
            console.error("Failed to load organization name:", error);
            this.organizationName = "Unknown Organization";
            this.cd.detectChanges();
        }
    };
}
